import React from 'react'
import styled from 'styled-components'
import { MqDesktop } from 'streamr-ui/css/consts'

const Wrapper = styled.ul`
    font-size: 16px;
    line-height: 32px;
    list-style: none;
    margin: 0;
    padding: 0;
    color: #0c009a;

    li:first-child {
        margin-bottom: 1.5rem;
    }

    @media ${MqDesktop} {
        font-size: 14px;
        line-height: 30px;
    }
`

const Title = styled.strong`
    color: #0c009a;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
`

const CaseStudyLinks = ({ title, children, ...props }) => (
    <Wrapper {...props}>
        <li $appear>
            <Title>{title}</Title>
        </li>
        {React.Children.map(children || [], (child) => (
            <li $appear>{child}</li>
        ))}
    </Wrapper>
)

export default CaseStudyLinks
